import { apiClient } from './client';
import { ProxyConfig, ProxyConfigUpdate, ProxyTestResponse } from '../types/proxy';

export const proxyApi = {
  // Get current proxy configuration
  getConfig: async (): Promise<ProxyConfig> => {
    const response = await apiClient.get('/api/v1/scraper/proxy-config/');
    return response.data;
  },

  // Update proxy configuration
  updateConfig: async (configId: string, config: ProxyConfigUpdate): Promise<ProxyConfig> => {
    const response = await apiClient.put(`/api/v1/scraper/proxy-config/${configId}`, config);
    return response.data;
  },

  // Test proxy configuration
  testConfig: async (): Promise<ProxyTestResponse> => {
    const response = await apiClient.post('/api/v1/scraper/proxy-config/test');
    return response.data;
  },

  // Get configuration history
  getHistory: async (limit: number = 10): Promise<any> => {
    const response = await apiClient.get(`/api/v1/scraper/proxy-config/history?limit=${limit}`);
    return response.data;
  },

  // Get proxy status
  getStatus: async (): Promise<any> => {
    const response = await apiClient.get('/api/v1/scraper/status/proxy-status');
    return response.data;
  },

  // Trigger proxy health check
  healthCheck: async (): Promise<any> => {
    const response = await apiClient.post('/api/v1/scraper/status/proxy-health-check');
    return response.data;
  },

  // Force proxy rotation
  rotateProxies: async (): Promise<any> => {
    const response = await apiClient.post('/api/v1/scraper/status/proxy-rotate');
    return response.data;
  },

  // Reload proxy configuration from database
  reloadConfig: async (): Promise<any> => {
    const response = await apiClient.post('/api/v1/scraper/status/proxy-reload');
    return response.data;
  },
};
